var a = /* @__PURE__ */ ((r) => (r.CALLBACK_APEIRON_SSO = "/callback/apeiron-sso/", r))(a || {});
export {
  a as ROUTE
};
//# sourceMappingURL=route.js.map
